<template>
  <section class="form-surface">
    <form class="form-panel" @submit.prevent="reset">
      <h1>Reset password</h1>
      <div v-if="message" class="workspace-alert">{{ message }}</div>
      <label class="form-row">
        <span>New password</span>
        <input v-model="password" type="password" />
      </label>
      <button type="submit">Reset password</button>
      <div class="form-actions muted-actions">
        <RouterLink class="app-link" to="/login">Back to login</RouterLink>
      </div>
    </form>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage } from '../stores/session';
import { validateRequiredPassword } from '../validation/userValidation';

const route = useRoute();
const password = ref('');
const message = ref<string | null>(null);

async function reset(): Promise<void> {
  const token = typeof route.query.token === 'string' ? route.query.token : '';
  if (!token) {
    message.value = 'Reset token is missing.';
    return;
  }

  const validationMessage = validateRequiredPassword(password.value);
  if (validationMessage != null) {
    message.value = validationMessage;
    return;
  }

  try {
    await CommandsService.commandResetPasswordCommand({ requestBody: { token, password: password.value } });
    message.value = 'Password reset.';
  } catch (error) {
    message.value = getErrorMessage(error, 'Unable to reset password.');
  }
}
</script>
